// extracted by mini-css-extract-plugin
export default {"icon-blue":"Icon_icon-blue__qpJq9","bg-yellow-dark":"Icon_bg-yellow-dark__uzJOy"};